import { atom } from "recoil";

export const usedIdAtom = atom<string[]>({
  key: "usedIdAtom",
  default: [],
});
